import { VMGetDiscussionBugRes } from "../core/types/VirtualMachineApi";
import ProviderFactory from "../core/ProviderFactory";
import ApexBugDbProvider from "../core/providers/apex/ApexBugDbProvider";
import {
  ProviderConfiguration,
  ApexProviderType,
} from "../core/types/Provider";
import UserModel from "./UserModel";

export default abstract class BugDbIntegrationModel {
  private static provider: ApexBugDbProvider = ProviderFactory.create(
    ApexProviderType.BugDB,
    ProviderConfiguration.apex
  );
  private static discussionBugCache: VMGetDiscussionBugRes = null;
  private static defaultBugDbAccountCache: string = null;

  public static getDiscussionBugCached(
    discussionId: number
  ): Promise<VMGetDiscussionBugRes> {
    return new Promise((resolve, reject) => {
      if (BugDbIntegrationModel.discussionBugCache === null) {
        BugDbIntegrationModel.provider
          .getDiscussionBug(discussionId)
          .then((discussionBugRes) => {
            BugDbIntegrationModel.discussionBugCache = discussionBugRes;
            resolve(discussionBugRes);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(BugDbIntegrationModel.discussionBugCache);
      }
    });
  }

  public static getDefaultBugDbAccountCached(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (BugDbIntegrationModel.defaultBugDbAccountCache === null) {
        UserModel.getCurrentUserCached()
          .then((self) => {
            return BugDbIntegrationModel.provider.getDefaultBugDbAccount(
              self.email
            );
          })
          .then((bugDbAccount) => {
            if (bugDbAccount.found) {
              BugDbIntegrationModel.defaultBugDbAccountCache =
                bugDbAccount.default_id;
              resolve(BugDbIntegrationModel.defaultBugDbAccountCache);
            } else {
              resolve(null);
            }
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(BugDbIntegrationModel.defaultBugDbAccountCache);
      }
    });
  }

  public static getBugDbAccount(bugDbAccount: string): Promise<string> {
    return new Promise((resolve, reject) => {
      BugDbIntegrationModel.provider
        .getBugDbAccount(bugDbAccount)
        .then((bugDbAccount) => {
          if (bugDbAccount.found) {
            resolve(bugDbAccount[0].BUG_USERNAME);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
